import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Radio/sgds-radio-group";
import { register } from "../../utils/ce-registry";

register("sgds-radio-group", Component);

export default createComponent({
  react: React,
  tagName: "sgds-radio-group",
  elementClass: Component,
  events: {
    onSgdsChange: "sgds-change"
  }
});
